import InputField from "../../../components/common/controls/InputField";

interface Props {
  data: any;
  imageSource: any;
  defaultText: string;
}

export default function TextFieldWithIcon(props: Props) {
  const { data, imageSource, defaultText } = props;

  return (
    <div className="inline-flex">
      <img src={imageSource} alt="input" />
      <InputField
        defaultValue={data ? data.title : defaultText}
        readOnly={true}
      />
    </div>
  );
}
